import React, { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import BookingModal from "./BookingModal";
import CookieConsent from "./CookieConsent";
import { Toaster } from "./ui/sonner";

export default function Layout() {
  const { pathname } = useLocation();
  return (
    <div className="bg-ink min-h-screen">
      <Navbar />
      <main>
        <div key={pathname} className="route-fade">
          <Suspense fallback={<div className="min-h-screen" />}>
            <Outlet />
          </Suspense>
        </div>
      </main>
      <Footer />
      <BookingModal />
      <CookieConsent />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}
